import React, { useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { RemarksBgIcon } from '../../../../../components/Icon';
import { Dialog } from '../../../../../components';
import Text from '../../../../../components/Text';

const useStyles = makeStyles(() => ({
  markicon: {
    fontSize: '1.25rem',
    color: '#c0c6cb',
    marginLeft: '0.38rem',
  },
}));

const MultiThresholdButton = ({ data, satelliteStore }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  return (
    <>
      <ButtonBase onClick={() => setOpen(true)}>
        <RemarksBgIcon className={classes.markicon} />
      </ButtonBase>
      {open && (
        <Dialog open={true} handleClose={() => setOpen(false)} title="Threshold Quantity" haveFoot={false}>
          <Box display="flex" flexDirection="column" gridGap="0.25rem">
            {satelliteStore && (
              <Box display="flex" alignItems="center" width="100%" height="3.3rem">
                <Text
                  color="#538FFF"
                  fontSize="1rem"
                  textTransform="uppercase"
                  fontWeight="700"
                  ml="1rem"
                  style={{ flexBasis: '45%' }}
                >
                  satellite store
                </Text>
                <Text
                  color="#538FFF"
                  fontSize="1rem"
                  textTransform="uppercase"
                  fontWeight="700"
                  ml="1rem"
                  style={{ flexBasis: '55%' }}
                >
                  Warning quantity
                </Text>
              </Box>
            )}
            {data.map((item, index) => (
              <Box
                display="flex"
                alignItems="center"
                width="100%"
                height="3.3rem"
                bgcolor={index % 2 === 0 ? '#F9F9F9' : '#ffffff'}
                key={item.id}
              >
                <Text
                  color="#2E4469"
                  fontSize="0.875rem"
                  textTransform="uppercase"
                  ml="1rem"
                  style={{ flexBasis: '45%' }}
                >
                  {item.store}
                </Text>
                <Text
                  color="#2E4469"
                  fontSize="0.875rem"
                  textTransform="uppercase"
                  ml="1rem"
                  style={{ flexBasis: '55%' }}
                >
                  {item.thresholdSettingsDay}
                </Text>
              </Box>
            ))}
          </Box>
        </Dialog>
      )}
    </>
  );
};

export default MultiThresholdButton;
